import { SITE } from '@/app/constants';

export interface VideoResource {
  url: string;
  poster: string[];
  poster1: string;
  mobilePoster1?: string;
}

// 视频配置
export const GLOBAL_VIDEO_RESOURCES_REFERENCE: VideoResource[] = [
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/reference1.ff0b3a2f.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/img2-c1764e1e.webp',
    mobilePoster1: 'https://image01.cf.vidu.studio/vidu/media-asset/img2-c1764e1e-2f34208e.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/reference1-2-4e4525f1.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/reference1-1-bed5b195.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/reference1-3-f8ca8a9a.webp',
    ],
  },
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/refrenceGlobal2.75cedbc6.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/reference3-f1082f32.webp',
    mobilePoster1: 'https://image01.cf.vidu.studio/vidu/media-asset/reference3-f1082f32-81955bbb.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/referenceGlobal2-2-8283ce61-e72fb731.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/referenceGlobal2-3-72933363-7d693bd0.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/referenceGlobal2-1-dd0a8c77-4513490b.webp',
    ],
  },
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/reference3.096cbbdb.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/img3-e44b1acc.webp',
    mobilePoster1: 'https://image01.cf.vidu.studio/vidu/media-asset/img3-e44b1acc-38d9a08c.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/reference3-1-aacd1e93.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/reference3-2-4dcf1a34.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/reference3-3-e48eac56.webp',
    ],
  },
];

// 视频配置
export const CHINA_VIDEO_RESOURCES_REFERENCE: VideoResource[] = [
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/reference1.5fbf6733.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/img2-c1764e1e.webp',
    mobilePoster1: 'https://image01.vidu.zone/vidu/media-asset/img2-c1764e1e-2f34208e.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/reference1-2-4e4525f1.webp',
      'https://image01.vidu.zone/vidu/media-asset/reference1-1-9e52dff8.webp',
      'https://image01.vidu.zone/vidu/media-asset/reference1-3-f8ca8a9a.webp',
    ],
  },
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/referenceChina2.7423dba0.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/img1-93bc80b8.webp',
    mobilePoster1: 'https://image01.vidu.zone/vidu/media-asset/img1-93bc80b8-21dc71b4.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/referenceChina2-1-fa6ce117.webp',
      'https://image01.vidu.zone/vidu/media-asset/referenceChina2-3-1da23e96-f8e9ecdf.webp',
      'https://image01.vidu.zone/vidu/media-asset/referenceChina2-2-6305572a.webp',
    ],
  },
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/reference3.ebfb8cc6.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/img3-e44b1acc.webp',
    mobilePoster1: 'https://image01.vidu.zone/vidu/media-asset/img3-e44b1acc-38d9a08c.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/reference3-1-aacd1e93.webp',
      'https://image01.vidu.zone/vidu/media-asset/reference3-2-4dcf1a34.webp',
      'https://image01.vidu.zone/vidu/media-asset/reference3-3-e48eac56.webp',
    ],
  },
];

// 视频配置
export const GLOBAL_VIDEO_RESOURCES_IMG: VideoResource[] = [
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/imageGlobal1.47868a52.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/imageGlobal1-2-74638297.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/imageGlobal1-2-74638297.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/imageGlobal1-1-59866e85.webp',
    ],
  },
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/man.23c0146e.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/man-f3f23e2e.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/man-first-b1805e6c.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/man-last-6cac2c1d.webp',
    ],
  },
  {
    url: 'https://image01.cf.vidu.studio/vidu/landing-page/image3.d24df352.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/image3-1-bce11a6b.webp',
    poster: [
      'https://image01.cf.vidu.studio/vidu/media-asset/image3-2-403ac060.webp',
      'https://image01.cf.vidu.studio/vidu/media-asset/image3-1-3ef70758.webp',
    ],
  },
];

// 视频配置
export const CHINA_VIDEO_RESOURCES_IMG: VideoResource[] = [
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/imageChina1.47868a52.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/reference1-bbd1f373.webp',
    mobilePoster1: 'https://image01.vidu.zone/vidu/media-asset/reference1-bbd1f373-2a842558.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/imageChina1-2-74638297.webp',
      'https://image01.vidu.zone/vidu/media-asset/imageChina1-1-59866e85.webp',
    ],
  },
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/man.23c0146e.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/man-f3f23e2e.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/man-first-b1805e6c.webp',
      'https://image01.vidu.zone/vidu/media-asset/man-last-6cac2c1d.webp',
    ],
  },
  {
    url: 'https://image01.vidu.zone/vidu/landing-page/image3.27771c78.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/image3-1-3ef70758.webp',
    poster: [
      'https://image01.vidu.zone/vidu/media-asset/image3-2-403ac060.webp',
      'https://image01.vidu.zone/vidu/media-asset/image3-1-3ef70758.webp',
    ],
  },
];

export const VIDEO_RESOURCES_REFERENCE =
  SITE === 'china' ? CHINA_VIDEO_RESOURCES_REFERENCE : GLOBAL_VIDEO_RESOURCES_REFERENCE;

export const VIDEO_RESOURCES_IMG = SITE === 'china' ? CHINA_VIDEO_RESOURCES_IMG : GLOBAL_VIDEO_RESOURCES_IMG;

const CHINA_VIDEO_RESOURCES_CLAW: VideoResource[] = [
  {
    url: 'https://image01.vidu.zone/vidu/media-asset/claw_showcase-0ea7e5aa.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/claw_showcase-e9b8a903.webp',
    poster: [],
  },
  {
    url: 'https://image01.vidu.zone/vidu/media-asset/claw_showcase2-97d22001.mp4',
    poster1: 'https://image01.vidu.zone/vidu/media-asset/claw_showcase2-c9e4c554.webp',
    poster: [],
  },
];

const GLOBAL_VIDEO_RESOURCES_CLAW: VideoResource[] = [
  {
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/claw_showcase-0ea7e5aa.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/claw_showcase-e9b8a903.webp',
    poster: [],
  },
  {
    url: 'https://image01.cf.vidu.studio/vidu/media-asset/claw_showcase2-97d22001.mp4',
    poster1: 'https://image01.cf.vidu.studio/vidu/media-asset/claw_showcase2-c9e4c554.webp',
    poster: [],
  },
];

export const VIDEO_RESOURCES_CLAW = SITE === 'china' ? CHINA_VIDEO_RESOURCES_CLAW : GLOBAL_VIDEO_RESOURCES_CLAW;
